angular.module('impactx.company').controller('ManufacturerListCtrl',[
    '$scope',
    'CompanyService',
    'selectedListItems',
    'PartialDialogsService',
    ManufacturerListCtrl]);

function ManufacturerListCtrl($scope, CompanyService, selectedListItems, PartialDialogsService) {
    var self = this;

    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.COMPANY,"manufacturerlist");

    self.deleteCompany = function(data) {
        CompanyService.deleteCompany(selectedListItems.getFirstSelectedItem(), true, $scope, false, '/company/manufacturer/delete', 'manufacturerListCtrl');
    };

    CompanyService.setCompanyListActions(self, selectedListItems);

    var buttonDefinition = [
        {
            label: "companyData",
            linkFunction: self.getCompanyDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "clientCompanyData",
            linkFunction: self.getClientCompanyDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "relations",
            linkFunction: self.getCompanyRelationDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "interface",
            linkFunction: self.getCompanyInterfaceDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {label: "delete", action: self.deleteCompany, condition: self.canDelete, process: 'EditCompany'}
    ];

    this.meta = {
        rowTemplate: 'modules/company/templates/manufacturerlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/company/manufacturerlist',
        id: "manufacturerlist",
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function() {
        return this.meta;
    };
}